import { gql } from '@apollo/client';

export const ADD_AGENDA = gql`
    mutation CreateAgendaMail($createAgendaMailInput: CreateAgendaMailInput!) {
        createAgendaMail(input: $createAgendaMailInput) {
            agendaMail {
              id
              enabled
              name
              header
              dayOfTheWeek
              dayOfTheMonth
              window
              hour
              timezoneName
              timezoneOffset
              retrospective
              startOnSchedule
              startNextDay
              sendIfEmpty
              archivePastAgendas
              showAttendees
              monitorUntagged
              createdAt
              updatedAt
              agendaRules {
                match
                calendarInstances {
                    calendar {
                        id
                    }
                }
                id
                invert
                pattern
                createdAt
                updatedAt
              }
            }
            errors {
                path
                message
            }
        }
    }
`;

export const DELETE_AGENDA = gql`
    mutation DeleteAgendaMail($deleteAgendaMailInput: DeleteAgendaMailInput!) {
        deleteAgendaMail(input: $deleteAgendaMailInput) {
            agendaMail {
                id
            }
        }
    }
`;

export const UPDATE_AGENDA = gql`
    mutation UpdateAgendaMail($updateAgendaMailInput: UpdateAgendaMailInput!) {
      updateAgendaMail(input: $updateAgendaMailInput) {
        agendaMail {
            id
            name
            enabled
            header
            dayOfTheWeek
            dayOfTheMonth
            window
            hour
            timezoneName
            timezoneOffset
            retrospective
            startOnSchedule
            startNextDay
            sendIfEmpty
            archivePastAgendas
            showAttendees
            monitorUntagged
            createdAt
            updatedAt
            agendaRules {
                match
                calendarInstances {
                    calendar {
                        id
                    }
                }
                id
                invert
                pattern
            }
        }
        errors {
            path
            message
        }
    }
}
`;

export const DEFAULT_AGENDA = gql`
    mutation SetDefaultAgendas($setDefaultAgendasInput: SetDefaultAgendasInput!) {
        setDefaultAgendas(input: $setDefaultAgendasInput) {
            setSuccessfully
            agendasNotSet
        }
    }
`;

export const SEND_UNSAVED_AGENDA_MAIL = gql`
    mutation SendUnsavedAgendaMail($sendUnsavedAgendaMailInput: SendUnsavedAgendaMailInput!) {
        sendUnsavedAgendaMail(input: $sendUnsavedAgendaMailInput) {
            sentSuccessfully
            notSentMessage

            errors {
                path
                message
            }
        }
    }
`;

export const SEND_EXISTING_AGENDA_MAIL = gql`
    mutation SendExistingAgendaMail($sendExistingAgendaMailInput: SendExistingAgendaMailInput!) {
        sendExistingAgendaMail(input: $sendExistingAgendaMailInput) {
            sentSuccessfully
            notSentMessage
        }
    }
`;

export const FETCH_CALENDARS = gql`
    query CalendarInstances {
        user {
            calendarInstances {
                id

                effectiveLabel

                visible

                primary
                writable

                account {
                    id
                    name
                    email

                    enabled
                    active
                    authorized
                }

                calendar {
                    id
                }

                createdAt
                updatedAt
            }
        }
    }
`;

export const FETCH_AGENDAS = gql`
    query AgendaMails($id: ID, $sortColumn: AgendaMailColumnsEnum, $sortDirection: SortDirectionEnum) {
        user {
            agendaMails(id: $id, sortColumn: $sortColumn, sortDirection: $sortDirection) {
                id
                enabled
                name
                header

                dayOfTheWeek
                dayOfTheMonth
                window

                hour
                timezoneName
                timezoneOffset

                retrospective
                startOnSchedule
                startNextDay
                showAttendees
                monitorUntagged
                sendIfEmpty
                archivePastAgendas

                agendaRules {
                    match
                    calendar: calendarInstances {
                        id

                        label: effectiveLabel

                        calendar {
                            id
                        }

                    }
                    id
                    invert
                    pattern
                }
            }
        }
    }
`;
